import React from "react";
import {NavLink, useNavigate} from "react-router-dom";
import * as Utils from "../inc/Utils";
import {Config} from "../Config";
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import MemberSidebar from "../inc/MemberSidebar";
import {confirmAlert} from "react-confirm-alert";

export default function DeleteAccount(prop) {
    let navigate = useNavigate();

    let member = prop.member;

    let btnTextDefault = 'ยืนยันการลบบัญชี';
    let btnTextLoading = 'กำลังลบบัญชี..';
    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState(null);

    let refDeleteReason = React.useRef();

    React.useEffect(() => {
        window.scrollTo(0, 0);

        document.title = 'ลบบัญชีผู้ใช้ - NCSA';

        (async function() {
            try {
                if(member) {
                    const resView = await Utils.getProfile(member);
                    setData(resView);
                }
            } catch (e) {
                //
            }
        })();

    }, []);

    const onSubmit = async () => {
        let deleteReason = refDeleteReason.current.value;

        if(!deleteReason) {
            toast.error("กรุณาระบุ เหตุผล");
            refDeleteReason.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ยืนยันการลบบัญชีนี้ ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let datetime = moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');

                            const body = {
                                deleteReason: deleteReason,
                                updatedBy: -1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                            };
                            fetch(Config.apiUrl +'/member/deleteAccountSelf', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': member.accessToken
                                }
                            }).then(async response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(async result => {
                                setLoading(true);
                                localStorage.removeItem(Utils.LOCAL_STORAGE_KEY);
                                if(result) {
                                    await sendEmail({
                                        name: result.name,
                                        email: result.email,
                                        reason: deleteReason,
                                        datetime: datetime
                                    });
                                    setLoading(false);

                                    toast.success("ระบบได้ทำการลบบัญชีผู้ใช้งานเรียบร้อยแล้ว");
                                    setTimeout(function () {
                                        window.location.href = (prop.lang === 'en' ? '/en':'/') + 'login';
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    async function sendEmail(param) {
        const response = await fetch(Config.phpUrl +'/email_delete_account.php', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="profile" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">

                            <div className="card-body p-0 px-xxl-3">
                                <h4 className="title-line-left mt-2 mb-3">{prop.lang === 'en' ? 'Delete Account':'ลบบัญชีผู้ใช้งาน'}</h4>
                            </div>

                            <div className="col-sm-12">
                                <div className="form-group">
                                    <h6>{prop.lang === 'en' ? 'Reason':'เหตุผล'} <span className="star">*</span></h6>
                                    <input type="text" className="form-control" ref={refDeleteReason} maxLength={100} />
                                </div>
                            </div>

                            <div className="buttons gap-15 pb-0 my-sm-4">
                                <button className="btn btn-primary" type="button" onClick={onSubmit} disabled={isLoading}>
                                    {prop.lang === 'en' ? 'Confirm Delete Account':'ยืนยันการลบบัญชี'}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 